import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Bubble, LoaderButton, Divider } from 'ctia-ui';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { loginCTIA, getUserInfo } from 'actions/user';
import { createMemberLoginLink } from 'helpers/FormHelper';

import 'containers/Login/style.css';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      name: '',
      password: '',
      loginError: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user && nextProps.user.accessError) {
      this.setState({ loginError: true, isLoading: false });
    }
  }

  validateForm() {
    return this.state.name.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    const param = event.target.id || event.target.name;

    this.setState({
      [param]: event.target.value
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    const { name, password } = this.state;
    this.props.loginCTIA(name, password, this.props.getUserInfo);
  };

  render() {
    return (
      <div className="Login">
        <h1 className="text-center" style={{ paddingBottom: 25 }}>
          CTIA User Login
        </h1>
        <form onSubmit={this.handleSubmit}>
          <Bubble type="danger" show={this.state.loginError}>
            Invalid Username or Password
          </Bubble>
          <FormGroup controlId="name" bsSize="large">
            <ControlLabel>Username</ControlLabel>
            <FormControl
              autoFocus
              value={this.state.name}
              onChange={this.handleChange}
            />
          </FormGroup>
          <FormGroup controlId="password" bsSize="large">
            <ControlLabel>Password</ControlLabel>
            <FormControl
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
            />
          </FormGroup>
          <LoaderButton
            block
            bsSize="large"
            bsStyle="info"
            disabled={!this.validateForm()}
            type="submit"
            isLoading={this.state.isLoading}
            text="Login as CTIA Staff"
            loadingText="Logging in…"
          />
          <Divider title="OR" />
          <a href={createMemberLoginLink()} className="app-button-link">
            <LoaderButton
              block
              bsSize="large"
              bsStyle="warning"
              text="Login as CBRS Member"
            />
          </a>
        </form>
      </div>
    );
  }
}

function mapStateToProps({ user }) {
  return { user };
}

export default connect(
  mapStateToProps,
  { loginCTIA, getUserInfo }
)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js